<template>
  <b-container fluid class="control-panel-cod">
    <h1 v-translate="{countdown}">COD Control <small>(Autorefresh in %{countdown}s)</small></h1>
    <div v-if="!$cookies.get('bypassCountry')">
      <b-row class="mb-4">
        <b-col>
          <label class="" for="inline-form-input-name" v-translate>Date Range <em>(120 days max.)</em></label><label v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRange" v-translate>reset range</a>]</label>
          <date-range-picker
            v-if="datepickerLocalized"
            v-model="updatedDateRange"
            :locale-data="locale"
            :opens="opens"
            class="mb-2 w-100"
            :ranges="ranges"
            @update="updateValues"
          >
            <div slot="input" slot-scope="picker">
              <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
              <span v-show="updatedDateRangeActive === 0" style="vertical-align: middle" v-translate>Today</span>
              <span v-show="updatedDateRangeActive !== 0" style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
            </div>
          </date-range-picker>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col v-for="(type, index) of codSummary" :key="index" md="6" lg="2" class="mb-3 mb-lg-0">
                <h4>{{type.label}} <b-badge>{{type.count}}</b-badge></h4>
                <h3>{{type.amount | currency(country)}}</h3>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="detail of codDetail" md="6" xl="4" :key="(detail.user.id || 'X')">
          <b-card>
            <b-row>
              <b-col>
                <user-card :user="detail.user" mini :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" class="mb-0" />
              </b-col>
              <b-col>
                <div v-for="(type, key) of detail.cod" :key="key">
                  {{codSummary[key].label}} <b-badge>{{type.count}}</b-badge> <b-badge variant="dark">{{type.amount | currency(country)}}</b-badge>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-alert variant="warning" class="my-3" show v-else>
      <h4 class="my-0" v-translate>You need to set a Country.</h4>
    </b-alert>
  </b-container>
</template>

<script>
import UserCard from '@/components/UserCard'
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'ControlPanelCod',
  components: {
    UserCard,
    DateRangePicker
  },
  data() {
    return {
      country: this.$cookies.get('country') || null,
      codSummary: {
        pending: {
          label: this.$gettext('Pending'),
          amount: null,
          count: null
        },
        created: {
          label: this.$gettext('Created'),
          amount: null,
          count: null
        },
        collected: {
          label: this.$gettext('Collected'),
          amount: null,
          count: null
        },
        deposited: {
          label: this.$gettext('Deposited'),
          amount: null,
          count: null
        },
        lost: {
          label: this.$gettext('Lost'),
          amount: null,
          count: null
        }
      },
      codDetail: [],
      timeoutCountdown: null,
      intervalCountdown: null,
      countdown: 60,
      date_from: this.moment().endOf('day'),
      date_to: this.moment().startOf('day'),
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {},
      ranges: {},
      updatedDateRangeActive: 0,
      datepickerLocalized: false
    }
  },
  created () {
    this.fetchVehicleTypes()
  },
  mounted () {
    this.initDatePicker()
    if (!this.$cookies.get('bypassCountry')) {
      this.setTimeout()
    } else {
      this.clearTimeout()
    }
  },
  methods: {
    initDatePicker() {
      this.locale = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday and Today')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(120, 'day').toDate(), this.moment().subtract(0, 'day').toDate()]
      }
      this.datepickerLocalized = true
    },
    resetupdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.date_to = this.moment(this.updatedDateRange.endDate)
      this.date_from = this.moment(this.updatedDateRange.startDate)
      this.updatedDateRangeActive = 0
      this.setTimeout()
    },
    updateValues(obj) {
      this.date_to = this.moment(this.updatedDateRange.endDate).endOf('day')
      this.date_from = this.moment(this.updatedDateRange.startDate).startOf('day')
      this.updatedDateRangeActive++
      this.setTimeout()
    },
    setTimeout() {
      clearTimeout(this.timeoutCountdown)
      this.timeoutCountdown = setTimeout(() => { this.setTimeout() }, 60000)
      this.getCodSummary()
        .then(() => {
          this.setIntervalCountdown()
        })
    },
    clearTimeout() {
      clearTimeout(this.timeoutCountdown)
      clearInterval(this.intervalCountdown)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    async getCodSummary() {
      let params = {
        date_from: this.date_from.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
        date_to: this.date_to.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'countries/' + this.country + '/cod-transactions/summary', {params})
        .then(response => {
          this.codDetail = response.body
          for (const type of Object.keys(this.codSummary)) {
            this.codSummary[type].amount = response.body.reduce((a, b) => a + (b.cod[type] ? b.cod[type].amount : 0), 0)
            this.codSummary[type].count = response.body.reduce((a, b) => a + (b.cod[type] ? b.cod[type].count : 0), 0)
          }
        })
    }
  }
}
</script>
